export var Shadows = {
  ShadowSm: 'shadow-sm',
  ShadowMd: 'shadow-md',
  ShadowLg: 'shadow-lg',
  ShadowXl: 'shadow-xl',
  Label: 'label',
  Header: 'header',
  HeaderPopup: 'header-popup',
  FooterPopup: 'footer-popup',
  LeftPanelMd: 'left-panel-md',
  RightPanelMd: 'right-panel-md',
  LeftPanelSm: 'left-panel-sm',
  RightPanelSm: 'right-panel-sm'
};